import Icon from '@mui/icons-material/Lock';
import { SvgIconPropsOverrides } from '../../../model/icon';

export default function LockIcon({ className = '', ...props }: SvgIconPropsOverrides) {
	return <Icon className={`${className}`} {...props} />;
}
